import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects`}</h2>
    <ProjectCard title="JisortApp" link="#" bg="linear-gradient(to right, #D585FF 0%, #00FFEE 100%)" mdxType="ProjectCard">
    <strong>
        -Backend: Python(FastAPI)
        <br />
        -Android: Kotlin(Jetpack Compose)
        <br />
        -Frontend: Vue.js
    </strong>
    <br />
    <br />
    Cloud-based solution solution that connects service providers and
    prospecting clients.
    </ProjectCard>
    <ProjectCard title="Vooli" link="#" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
    <strong>
        -Backend: Python(Django)
        <br />
        -Android: Kotlin, Java
    </strong>
    <br />
    <br />
    A seamless, accessible and secure on demand insurance platform that seeks to
    cater to the 97 % who are uninsured and underinsured across Africa.
    </ProjectCard>
    <ProjectCard title="NikoPlay" link="#" bg="linear-gradient(to right, #662D8C 0%, #ED1E79 100%)" mdxType="ProjectCard">
    <strong>
        -Backend: Python(Django)
        <br />
        -Frontend: Vue.js
    </strong>
    <br />
    <br />
    Online quiz app
    </ProjectCard>
    <ProjectCard title="MarketForce360" link="#" //bg="linear-gradient(to right, #D28589 0%, #00FFEE 100%)"
    bg="linear-gradient(to left, #662D8C 0%, #ED1E79 100%)" mdxType="ProjectCard">
    <strong>
        -Android: Kotlin, Java
    </strong>
    <br />
    <br />
    MarketForce™ is a cloud-based sales and distribution management solution that enables businesses to digitize
    the entire sales and distribution process.
    </ProjectCard>
    <ProjectCard title="Timesheet" link="#" bg="linear-gradient(to right, #009245 0%, #FCEE21 100%)" mdxType="ProjectCard">
    <strong>
        -Android: Kotlin
    </strong>
    <br />
    <br />
    Android application to keep track of user tasks and time spent on each task to help companies keep remote track
    of their employees service delivery to aid payment processes. Interacting with GraphQL backend.
    </ProjectCard>
    <ProjectCard title="Songa" link="#" bg="linear-gradient(to RIGHT, #A48585 0%, #00FFEE 100%)" mdxType="ProjectCard">
    <strong>
        -Android: Kotlin
    </strong>
    <br />
    <br />
    A music streaming application with a large catalog of local and international
    content
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      